import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CheckPhoneMutationRequest, CheckPhoneMutationResponse, CheckPhone403, CheckPhone500 } from "../types/CheckPhone";

/**
 * @summary Проверка телефона
 * @link /api/auth/check/phone
 */

export function useCheckPhone <TData = CheckPhoneMutationResponse, TError = CheckPhone403 | CheckPhone500, TVariables = CheckPhoneMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/auth/check/phone`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
